var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAnchor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,15v1.59l-1.56,1.56-3.44,1.38v-7.52h3v-2h-3v-2h.15l.87-.5,1.16-2v-1l-1.16-2-.87-.5h-2.31l-.87,.5-1.16,2v1l1.16,2,.87,.5h.15v2h-3v2h3v7.52l-3.44-1.38-1.56-1.56v-1.59h-2v2l.29,.71,2,2,.34,.22,5,2h.74l5-2,.34-.22,2-2,.29-.71v-2h-2ZM10.85,5l.58-1h1.15l.58,1-.58,1h-1.15l-.58-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnchor);
export default __webpack_public_path__ + "static/1776855102/media/icon-anchor.7eef8c2229560f1b0244d05e967131ae.svg";
export { ForwardRef as ReactComponent };